import { requestGscApi } from '../GscTools/request';

/**
 * Inspects one URL through the URL Inspection endpoint, with the OAuth credentials linked to
 * `credentialsDomainId` — the same borrowed credentials the Search Analytics proxy uses.
 *
 * A spent quota is marked on the thrown error, because the page treats it differently from every
 * other failure: the previous result for the same URL stays on screen, labelled as not refreshed,
 * instead of being replaced by an error.
 */
export function inspectUrl({ credentialsDomainId, siteUrl, inspectionUrl, languageCode }) {
    return requestGscApi('/api/v1/domains/gsc-url-inspection/', {
        method: 'POST',
        body: {
            domain_id: credentialsDomainId,
            site_url: siteUrl,
            inspection_url: inspectionUrl,
            language_code: languageCode,
        },
    });
}
